import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-menu\"><path d=\"M170.666667 170.666667h298.666666v298.666666H170.666667z m0 384h298.666666v298.666666H170.666667z m384-384h298.666666v298.666666h-298.666666z m0 384h298.666666v298.666666h-298.666666z\" p-id=\"1481\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol